export default "__VITE_ASSET__DUI4sVTT__"